import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { InvoiceStatus } from '../../../services/dto/invoice-status';
import { InvoiceStatusComponent } from '../../invoice-status/invoice-status.component';

@Component({
  host: { 'data-cid': 'grid-invoice-status-cell' },
  imports: [InvoiceStatusComponent],
  selector: '',
  template: `<div class="align-center" style="height: 100%">
    <cam-invoice-status [status]="this.status"></cam-invoice-status>
  </div>`,
})
export class GridInvoiceStatusCellComponent extends AbstractCellComponent<any, InvoiceStatus> {
  get status() {
    return this.value ?? InvoiceStatus.Unknown;
  }
}
